<template>
  <AppContainer v-if="page" class="my-10 md:my-20">
    <header class="row justify-between lg:flex-row-reverse">
      <div v-if="page.image" class="col-lg-6 mb-3 md:mb-6 lg:mb-0">
        <AppImage
          :src="page.image"
          :alt="page.title"
        ></AppImage>
      </div>

      <div :class="page.image ? 'col-lg-5' : 'col-lg-12'">
        <div class="hidden md:block">
          <AppBreadcrumbs class="!mb-3" :items="breadcrumbsItems" />
        </div>

        <h1 class="mb-2 md:mb-3">{{ page.title }}</h1>

        <div
          v-if="description"
          class="cms-content mb-auto"
          v-html="description"
        ></div>
      </div>
    </header>

    <div v-if="body" class="cms-content mt-6 md:mt-10" v-html="body"></div>
  </AppContainer>
</template>

<script setup lang="ts">
import type { ApiInfoResponse } from '~/server/api/info'

const props = defineProps<{
  breadcrumbs: ApiInfoResponse['breadcrumbs']
  page: ApiInfoResponse['page']
}>()

// Content pasted into the CMS editor can arrive with every space as a
// non-breaking one, which stops the text wrapping and pushes it wider than the
// page container (BOAT-1971: the privacy policy).
const normaliseSpaces = (html?: string | null) =>
  html ? html.replace(/&nbsp;|\u00A0/g, ' ') : html

const description = computed(() => normaliseSpaces(props.page.description))
const body = computed(() => normaliseSpaces(props.page.body))

const breadcrumbsItems = computed(() =>
  props.breadcrumbs.map((item) => ({
    title: item.title,
    href: cleanPath('/', item.path),
  })),
)
</script>
